var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{style:('border-color: ' + this.color),attrs:{"id":"quote"}},[_c('p',{attrs:{"id":"quote-text"}},[_vm._v(_vm._s('"' + _vm.quote + '"')),_c('br'),_c('i',{attrs:{"id":"author"}},[_vm._v("— "+_vm._s(_vm.author))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }